export default __webpack_public_path__ + "static/media/koren.a5ca2753.webp";